"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostGreConnectionFactoryFromJS = exports.PostGreConnectionFactory = void 0;
const immutable_1 = require("immutable");
const IConnection_1 = require("./IConnection");
const IPostGreSQL_1 = require("./properties/IPostGreSQL");
exports.PostGreConnectionFactory = (0, immutable_1.Record)(Object.assign(Object.assign({}, (0, IConnection_1.ConnectionFactory)().toJS()), { type: 4 /* EConnectionTypes.POSTGRESQL */, properties: (0, IPostGreSQL_1.PostGreSQLPropertiesFactory)() }));
const PostGreConnectionFactoryFromJS = function (data) {
    return (0, exports.PostGreConnectionFactory)(Object.assign(Object.assign({}, (0, IConnection_1.ConnectionFactoryFromJS)(data).toJS()), { type: 4 /* EConnectionTypes.POSTGRESQL */, properties: (0, IPostGreSQL_1.PostGreSQLPropertiesFactoryFromJS)(data.properties) }));
};
exports.PostGreConnectionFactoryFromJS = PostGreConnectionFactoryFromJS;
//# sourceMappingURL=IPostGreConnection.js.map